// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"846700d1","453":"540fcd86","455":"bf2c0e4e","977":"e93f0fc6"}[chunkId] + ".chunk.js";
};